// Course text comes from a CMS export and still carries HTML entities, so the page
// printed things like "0&deg;&nbsp;centigrade" literally. Decode them at render time
// rather than trusting the stored copy to stay clean.
//
// This is deliberately a lookup table rather than an innerHTML round-trip: assigning
// untrusted text to innerHTML to let the browser decode it would also let markup
// through, and this text is editable from the admin screens.
const NAMED_ENTITIES = {
  amp: "&",
  lt: "<",
  gt: ">",
  quot: '"',
  apos: "'",
  nbsp: " ",
  deg: "°",
  plusmn: "±",
  times: "×",
  divide: "÷",
  frac12: "½",
  frac14: "¼",
  frac34: "¾",
  hellip: "…",
  mdash: "—",
  ndash: "–",
  minus: "−",
  lsquo: "‘",
  rsquo: "’",
  ldquo: "“",
  rdquo: "”",
  laquo: "«",
  raquo: "»",
  bull: "•",
  middot: "·",
  dagger: "†",
  copy: "©",
  reg: "®",
  trade: "™",
  euro: "€",
  pound: "£",
  swap: "⇄",
  rarr: "→",
  larr: "←",
  harr: "↔",
  sup2: "²",
  sup3: "³",
  eacute: "é",
  egrave: "è",
  ecirc: "ê",
  agrave: "à",
  acirc: "â",
  ccedil: "ç",
  icirc: "î",
  ocirc: "ô",
  ugrave: "ù",
  ucirc: "û",
  euml: "ë",
  iuml: "ï",
  uuml: "ü",
  oelig: "œ",
};

export function decodeEntities(input) {
  if (typeof input !== "string" || input.indexOf("&") === -1) return input;

  return input
    // numeric: &#176; and &#xB0;
    .replace(/&#(\d+);/g, (whole, code) => {
      const value = Number(code);
      return Number.isFinite(value) ? String.fromCodePoint(value) : whole;
    })
    .replace(/&#x([0-9a-f]+);/gi, (whole, code) => {
      const value = parseInt(code, 16);
      return Number.isFinite(value) ? String.fromCodePoint(value) : whole;
    })
    // named, from the table above; anything unknown is left exactly as it was
    .replace(/&([a-z][a-z0-9]*);/gi, (whole, name) => {
      const decoded = NAMED_ENTITIES[name.toLowerCase()];
      return decoded === undefined ? whole : decoded;
    });
}

export default decodeEntities;
